import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Nav from "@/components/Nav";
import { toast } from "sonner";

export default function PasswordReset() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [sent, setSent] = useState(false);
  const [done, setDone] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/password-reset/request", { email, origin_url: window.location.origin }); setSent(true); }
    catch { toast.error("Try again"); }
  };
  const confirm = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/password-reset/confirm", { token, new_password: pw }); setDone(true); setTimeout(()=>nav("/auth"), 1500); }
    catch (e) { toast.error(e?.response?.data?.detail || "Invalid or expired token"); }
  };

  return (
    <div><Nav />
      <div className="max-w-md mx-auto px-5 py-14">
        <div className="rounded-2xl bg-[#131E36] border border-[#E0A96D]/10 p-7">
          <h1 className="font-serif text-3xl mb-4">{token ? "Set a new password" : "Reset your password"}</h1>
          {!token && !sent && (
            <form onSubmit={request} className="space-y-3">
              <input type="email" required placeholder="Your account email" value={email} onChange={e=>setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg bg-[#0E172A] border border-slate-700 focus:border-[#E0A96D] outline-none" data-testid="pwr-email" />
              <button className="w-full py-3 rounded-lg bg-[#E0A96D] text-[#070C18] font-semibold hover:bg-[#F0C28B]" data-testid="pwr-request">Send reset link</button>
            </form>
          )}
          {!token && sent && <p className="text-slate-300" data-testid="pwr-sent">If an account exists for that email, we sent a secure reset link. It expires in 60 minutes.</p>}
          {token && !done && (
            <form onSubmit={confirm} className="space-y-3">
              <input type="password" required placeholder="New password (min 6)" value={pw} onChange={e=>setPw(e.target.value)}
                className="w-full px-4 py-3 rounded-lg bg-[#0E172A] border border-slate-700 focus:border-[#E0A96D] outline-none" data-testid="pwr-password" />
              <button className="w-full py-3 rounded-lg bg-[#E0A96D] text-[#070C18] font-semibold hover:bg-[#F0C28B]" data-testid="pwr-confirm">Update password</button>
            </form>
          )}
          {done && <p className="text-emerald-300" data-testid="pwr-done">Updated. Redirecting to sign in…</p>}
        </div>
      </div>
    </div>
  );
}
